const shuixi01 = require("@/assets/images/laundryTemp/shuiXi/shuixi01.png");
const shuixi02 = require("@/assets/images/laundryTemp/shuiXi/shuixi02.png");
const shuixi03 = require("@/assets/images/laundryTemp/shuiXi/shuixi03.png");
const shuixi04 = require("@/assets/images/laundryTemp/shuiXi/shuixi04.png");
const shuixi05 = require("@/assets/images/laundryTemp/shuiXi/shuixi05.png");
const shuixi06 = require("@/assets/images/laundryTemp/shuiXi/shuixi06.png");
const shuixi07 = require("@/assets/images/laundryTemp/shuiXi/shuixi07.png");
const shuixi08 = require("@/assets/images/laundryTemp/shuiXi/shuixi08.png");
const shuixi09 = require("@/assets/images/laundryTemp/shuiXi/shuixi09.png");
const shuixi10 = require("@/assets/images/laundryTemp/shuiXi/shuixi10.png");
const shuixi11 = require("@/assets/images/laundryTemp/shuiXi/shuixi11.png");
const shuixi12 = require("@/assets/images/laundryTemp/shuiXi/shuixi12.png");
const shuixi13 = require("@/assets/images/laundryTemp/shuiXi/shuixi13.png");
const shuixi14 = require("@/assets/images/laundryTemp/shuiXi/shuixi14.png");

const piaobai01 = require("@/assets/images/laundryTemp/piaoBai/piaobai01.png");
const piaobai02 = require("@/assets/images/laundryTemp/piaoBai/piaobai02.png");
const piaobai03 = require("@/assets/images/laundryTemp/piaoBai/piaobai03.png");

const ganzao01 = require("@/assets/images/laundryTemp/ganZao/piaobai01.png");
const ganzao02 = require("@/assets/images/laundryTemp/ganZao/piaobai02.png");
const ganzao03 = require("@/assets/images/laundryTemp/ganZao/piaobai03.png");
const ganzao04 = require("@/assets/images/laundryTemp/ganZao/piaobai04.png");
const ganzao05 = require("@/assets/images/laundryTemp/ganZao/piaobai05.png");
const ganzao06 = require("@/assets/images/laundryTemp/ganZao/piaobai06.png");
const ganzao07 = require("@/assets/images/laundryTemp/ganZao/piaobai07.png");
const ganzao08 = require("@/assets/images/laundryTemp/ganZao/piaobai08.png");

const fanzhuan01 = require("@/assets/images/laundryTemp/fanZhuan/fanzhuan01.png");
const fanzhuan02 = require("@/assets/images/laundryTemp/fanZhuan/fanzhuan02.png");
const fanzhuan03 = require("@/assets/images/laundryTemp/fanZhuan/fanzhuan03.png");

const yuntang01 = require("@/assets/images/laundryTemp/yunTang/yuntang01.png");
const yuntang02 = require("@/assets/images/laundryTemp/yunTang/yuntang02.png");
const yuntang03 = require("@/assets/images/laundryTemp/yunTang/yuntang03.png");
const yuntang04 = require("@/assets/images/laundryTemp/yunTang/yuntang04.png");

const ganxi01 = require("@/assets/images/laundryTemp/ganXi/ganxi01.png");
const ganxi02 = require("@/assets/images/laundryTemp/ganXi/ganxi02.png");
const ganxi03 = require("@/assets/images/laundryTemp/ganXi/ganxi03.png");
const ganxi04 = require("@/assets/images/laundryTemp/ganXi/ganxi04.png");
const ganxi05 = require("@/assets/images/laundryTemp/ganXi/ganxi05.png");

const shixi01 = require("@/assets/images/laundryTemp/shiXi/shixi01.png");
const shixi02 = require("@/assets/images/laundryTemp/shiXi/shixi02.png");
const shixi03 = require("@/assets/images/laundryTemp/shiXi/shixi03.png");
const shixi04 = require("@/assets/images/laundryTemp/shiXi/shixi04.png");


export const icon1s = [
    {
        url: shuixi01,
        value: "/images/laundryTemp/shuiXi/shuixi01.png",
    },
    {
        url: shuixi02,
        value: "/images/laundryTemp/shuiXi/shuixi02.png",
    },
    {
        url: shuixi03,
        value: "/images/laundryTemp/shuiXi/shuixi03.png",
    },
    {
        url: shuixi04,
        value: "/images/laundryTemp/shuiXi/shuixi04.png",
    },
    {
        url: shuixi05,
        value: "/images/laundryTemp/shuiXi/shuixi05.png",
    },
    {
        url: shuixi06,
        value: "/images/laundryTemp/shuiXi/shuixi06.png",
    },
    {
        url: shuixi07,
        value: "/images/laundryTemp/shuiXi/shuixi07.png",
    },
    {
        url: shuixi08,
        value: "/images/laundryTemp/shuiXi/shuixi08.png",
    },
    {
        url: shuixi09,
        value: "/images/laundryTemp/shuiXi/shuixi09.png",
    },
    {
        url: shuixi10,
        value: "/images/laundryTemp/shuiXi/shuixi10.png",
    },
    {
        url: shuixi11,
        value: "/images/laundryTemp/shuiXi/shuixi11.png",
    },
    {
        url: shuixi12,
        value: "/images/laundryTemp/shuiXi/shuixi12.png",
    },
    {
        url: shuixi13,
        value: "/images/laundryTemp/shuiXi/shuixi13.png",
    },
    {
        url: shuixi14,
        value: "/images/laundryTemp/shuiXi/shuixi14.png",
    },
]

export const icon2s = [
    {
        url: piaobai01,
        value: "/images/laundryTemp/piaoBai/piaobai01.png",
    },
    {
        url: piaobai02,
        value: "/images/laundryTemp/piaoBai/piaobai02.png",
    },
    {
        url: piaobai03,
        value: "/images/laundryTemp/piaoBai/piaobai03.png",
    },
]

export const icon3s = [
    {
        url: ganzao01,
        value: "/images/laundryTemp/ganZao/piaobai01.png",
    },
    {
        url: ganzao02,
        value: "/images/laundryTemp/ganZao/piaobai02.png",
    },
    {
        url: ganzao03,
        value: "/images/laundryTemp/ganZao/piaobai03.png",
    },
    {
        url: ganzao04,
        value: "/images/laundryTemp/ganZao/piaobai04.png",
    },
    {
        url: ganzao05,
        value: "/images/laundryTemp/ganZao/piaobai05.png",
    },
    {
        url: ganzao06,
        value: "/images/laundryTemp/ganZao/piaobai06.png",
    },
    {
        url: ganzao07,
        value: "/images/laundryTemp/ganZao/piaobai07.png",
    },
    {
        url: ganzao08,
        value: "/images/laundryTemp/ganZao/piaobai08.png",
    },
]

export const icon4s = [
    {
        url: fanzhuan01,
        value: "/images/laundryTemp/fanZhuan/fanzhuan01.png",
    },
    {
        url: fanzhuan02,
        value: "/images/laundryTemp/fanZhuan/fanzhuan02.png",
    },
    {
        url: fanzhuan03,
        value: "/images/laundryTemp/fanZhuan/fanzhuan03.png",
    },
]

export const icon5s = [
    {
        url: yuntang01,
        value: "/images/laundryTemp/yunTang/yuntang01.png",
    },
    {
        url: yuntang02,
        value: "/images/laundryTemp/yunTang/yuntang02.png",
    },
    {
        url: yuntang03,
        value: "/images/laundryTemp/yunTang/yuntang03.png",
    },
    {
        url: yuntang04,
        value: "/images/laundryTemp/yunTang/yuntang04.png",
    },
]

export const icon6s = [
    {
        url: ganxi01,
        value: "/images/laundryTemp/ganXi/ganxi01.png",
    },
    {
        url: ganxi02,
        value: "/images/laundryTemp/ganXi/ganxi02.png",
    },
    {
        url: ganxi03,
        value: "/images/laundryTemp/ganXi/ganxi03.png",
    },
    {
        url: ganxi04,
        value: "/images/laundryTemp/ganXi/ganxi04.png",
    },
    {
        url: ganxi05,
        value: "/images/laundryTemp/ganXi/ganxi05.png",
    },
]

export const icon7s = [
    {
        url: shixi01,
        value: "/images/laundryTemp/shiXi/shixi01.png",
    },
    {
        url: shixi02,
        value: "/images/laundryTemp/shiXi/shixi02.png",
    },
    {
        url: shixi03,
        value: "/images/laundryTemp/shiXi/shixi03.png",
    },
    {
        url: shixi04,
        value: "/images/laundryTemp/shiXi/shixi04.png",
    },
]